import { takeLatest, put, call } from 'redux-saga/effects';
import CompOffReportTypes from './CompOffReport.types';
import { getAllCompOffByOrg } from './CompOffReport.services';
import { getAllCompOffByOrgSuccess, getAllCompOffByOrgFailure } from './CompOffReport.action';
import { encryptData, decryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

export function* getAllCompOffByOrgSaga(payload: any) {
	try {
		if (process.env.NODE_ENV === 'development') console.log('CompOff Report saga started with payload:', payload.payload);
		const compOffReportData = {
			organisationID: payload.payload.organisationID,
			startDate: payload.payload.startDate,
			endDate: payload.payload.endDate,
		};
		const encryptedData = encryptData(
			compOffReportData,
			CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_KEY,
		);
		if (process.env.NODE_ENV === 'development') console.log('Data encrypted, calling API...');
		// @ts-ignore
		const responseData = yield call(getAllCompOffByOrg as any, encryptedData);
		if (process.env.NODE_ENV === 'development') console.log('API Response:', responseData.data);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success' && responseData.data.response) {
				// Decrypt the response
				const decryptedData = decryptData(
					responseData.data.response,
					CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_KEY,
				);
				if (process.env.NODE_ENV === 'development') console.log('Data decrypted successfully:', decryptedData);
				yield put(getAllCompOffByOrgSuccess(decryptedData));
			} else {
				if (process.env.NODE_ENV === 'development') console.log('API returned error');
				yield put(
					getAllCompOffByOrgFailure(
						responseData.data.message_text || 'Failed to fetch comp off report',
					),
				);
			}
		}
	} catch (error: any) {
		if (process.env.NODE_ENV === 'development') console.error('Error in getAllCompOffByOrgSaga:', error);
		yield put(
			getAllCompOffByOrgFailure(
				error?.response?.data?.message_text || error?.message || 'An error occurred',
			),
		);
	}
}

export function* CompOff() {
	if (process.env.NODE_ENV === 'development') console.log('CompOff Report saga watcher started');
	yield takeLatest(CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_START, getAllCompOffByOrgSaga);
}
